import type { Product } from '../types';

export function productSlug(name: string) {
  return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export function productPath(product: Product) {
  return `/products/${productSlug(product.name)}`;
}
